import { render, staticRenderFns } from "./WhatsAppWebConfiguration.vue?vue&type=template&id=44a97e45&scoped=true&"
import script from "./WhatsAppWebConfiguration.vue?vue&type=script&lang=js&"
export * from "./WhatsAppWebConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppWebConfiguration.vue?vue&type=style&index=0&id=44a97e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a97e45",
  null
  
)

export default component.exports